import { Calendar, Video, Users } from 'lucide-react';

const Workshops = () => {
  const workshops = [
    {
      title: "Cybersecurity Bootcamp",
      description: "Hands-on bootcamp with Nixsecura Services covering cybersecurity fundamentals and career paths.",
      date: "October 2023",
      format: "Hybrid",
      speaker: "Nixsecura Experts",
      category: "Technical",
      image: "/workshop-cybersecurity.jpg"
    },
    {
      title: "Machine Learning Webinar",
      description: "Practical guide to ML basics and career opportunities in the field.",
      date: "October 2023",
      format: "Online",
      speaker: "Industry Experts",
      category: "Technical",
      image: "/workshop-ml.jpg"
    },
    {
      title: "Design Career Session",
      description: "Exploring opportunities and career paths in digital design.",
      date: "2023",
      format: "Online Webinar",
      speaker: "Josiah Peace",
      category: "Design",
      image: "/workshop-design.jpg"
    },
    {
      title: "Placement Mindset Webinar",
      description: "Strategic career planning from first year to corporate placement.",
      date: "November 2025",
      format: "Online",
      speaker: "Naseer Shaikh",
      category: "Career",
      image: "/workshop-placement.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1 bg-[#F4FAF9] rounded-full text-[#0C7779] text-sm font-medium mb-3">
            PAST SESSIONS
          </div>
          <h1 className="text-4xl font-bold mb-4 text-[#0F172A]">Our Workshops</h1>
          <p className="text-[#64748B] max-w-2xl mx-auto text-lg">
            Practical learning sessions focused on real skills and career guidance.
          </p>
        </div>

        {/* Workshops Grid */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {workshops.map((workshop, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl border border-[#E2EFEA] hover:border-[#249E94]/40 hover:shadow-sm transition-all duration-300 overflow-hidden"
              >
                {/* Workshop Image */}
                <div className="relative h-48">
                  <img 
                    src={workshop.image}
                    alt={workshop.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback if image doesn't load
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `
                        <div class="absolute inset-0 bg-gradient-to-br from-[#F4FAF9] to-white flex items-center justify-center">
                          <div class="text-center">
                            <div class="w-12 h-12 bg-[#3BC1A8]/20 rounded-full flex items-center justify-center mx-auto mb-3">
                              <svg class="w-6 h-6 text-[#0C7779]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            </div>
                            <span class="text-sm text-[#64748B]">Workshop Poster</span>
                          </div>
                        </div>
                      `;
                    }}
                  />
                  {/* Category Badge */}
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-[#3BC1A8] text-white text-xs font-medium rounded-full">
                      {workshop.category}
                    </span>
                  </div>
                  {/* Status Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-[#F4FAF9] text-[#0C7779] text-xs font-medium rounded-full">
                      Completed
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#0F172A] mb-3">{workshop.title}</h3>
                  <p className="text-[#64748B] text-sm mb-4 leading-relaxed">{workshop.description}</p>

                  {/* Details */}
                  <div className="space-y-3 border-t border-[#E2EFEA] pt-4">
                    <div className="flex items-center text-[#64748B] text-sm">
                      <Calendar className="w-4 h-4 mr-3 text-[#0C7779]" />
                      <span>{workshop.date}</span>
                    </div>
                    <div className="flex items-center text-[#64748B] text-sm">
                      <Video className="w-4 h-4 mr-3 text-[#0C7779]" />
                      <span>{workshop.format}</span>
                    </div>
                    <div className="flex items-center text-[#64748B] text-sm">
                      <Users className="w-4 h-4 mr-3 text-[#0C7779]" />
                      <span>{workshop.speaker}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="max-w-md mx-auto mt-16 text-center">
          <div className="bg-gradient-to-b from-[#F4FAF9] to-white rounded-xl p-8 border border-[#E2EFEA]">
            <h3 className="text-lg font-bold text-[#0F172A] mb-4">Stay Updated on Future Sessions</h3>
            <p className="text-[#64748B] text-sm mb-6">
              Join our community to be notified about upcoming workshops and learning opportunities.
            </p>
            <a 
              href="/community" 
              className="inline-block px-6 py-3 bg-[#249E94] text-white rounded-lg text-sm font-medium hover:bg-[#1D867C] transition-colors"
            >
              Join Community
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Workshops;